import { render, staticRenderFns } from "./DeclarationModal.vue?vue&type=template&id=1c3a4a96&scoped=true&"
import script from "./DeclarationModal.vue?vue&type=script&lang=js&"
export * from "./DeclarationModal.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationModal.vue?vue&type=style&index=0&id=1c3a4a96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3a4a96",
  null
  
)

export default component.exports